import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid, Paper } from "@material-ui/core";
import { useSelector } from "react-redux";
import useUsers from "src/hooks/useUsers";
import { useSnackbar } from "notistack";
import { Alert } from "@material-ui/lab";
import { getSurveys } from "src/services/admin/vote";
import { HowToVote } from "@material-ui/icons";
import { NoInfo } from "src/components/Common";
import NewSurvey from "./New/NewSurvey";
import TablaSurvey from "./Tabla/TablaSurvey";
import useStyles from "../votacion/Styles";

const Encuestas = () => {
  const { t: tGlobal } = useTranslation("global");
  const { t: tSurvey } = useTranslation("survey");
  const classes = useStyles();
  const { usuarios } = useUsers();
  const { enqueueSnackbar } = useSnackbar();
  const conjunto = useSelector((state) => state.complex.complex);
  const [encuestas, setEncuestas] = useState([]);

  useEffect(() => {
    const observer = (snapshot) => {
      try {
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setEncuestas(data);
      } catch (error) {
        enqueueSnackbar(tSurvey("error_load_surveys"), {
          variant: "error",
        });
      }
    };

    const unsubscribe = getSurveys(conjunto.id, observer);
    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [conjunto.id, enqueueSnackbar]);

  return (
    <Paper className={classes.root}>
      <div>
        <h3>
          <HowToVote /> {tGlobal("surveys")}
        </h3>
      </div>
      <Grid item xs={12}>
        <Alert severity="info">
          {tSurvey("info_index1")}
          <br />
          {tSurvey("info_index2")}
          <br />
          {tSurvey("info_index3")}
        </Alert>
      </Grid>
      <NewSurvey
        encuestas={encuestas}
        conjunto={conjunto}
        tGlobal={tGlobal}
        tSurvey={tSurvey}
      />
      {encuestas.length > 0 ? (
        <TablaSurvey
          encuestas={encuestas}
          conjunto={conjunto}
          usuarios={usuarios}
          tGlobal={tGlobal}
          tSurvey={tSurvey}
        />
      ) : (
        <NoInfo />
      )}
    </Paper>
  );
};

export default Encuestas;
